import React, { useEffect, useState, useContext } from "react";
import { withRouter } from "react-router-dom";
import { Spinner, Badge } from "react-bootstrap";
import API from "../../../utils/API";
import PsContext from "../../../context/PsContext";
import { Api } from "../../../utils/Variables";

const OrderDetails = (props) => {
  const { uid } = props.match.params;
  const context = useContext(PsContext);
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [address, setAddress] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const orderRes = await API.get(`v1/site/getorderbyid/${uid}`);
        if (orderRes.data.status === "1") {
          const orderData = orderRes.data.data;
          setOrders(orderData);

          const addressRes = await API.get(
            `v1/site/getcustomeraddressbyid/${orderData[0].customerid}`
          );
          if (addressRes.data.status === "1") {
            setAddress(addressRes.data.data);
          }
        }
      } catch (err) {
        console.error("Error fetching data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [uid]);

  return (
    <>
      <div className="tf-page-title">
        <div className="container-full text-center">
          <div className="heading">Order Details</div>
          <p className="text-2 text_black-2 mt_5">
            Check your order details and status
          </p>
        </div>
      </div>

      <div>
        <section
          className="colors"
          style={{
            backgroundColor: "#f7f8f7",
            paddingTop: "50px",
            paddingBottom: "30px",
          }}
        >
          <div className="container">
            {loading ? (
              <div className="text-center">
                <Spinner animation="border" />
              </div>
            ) : (
              <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div
                    className="card w-100 h-100 bb"
                    style={{ padding: "14px 15px" }}
                  >
                    {orders.map((order, index) => (
                      <div
                        key={index}
                        className="card w-100 h-100 bb mb-4"
                        style={{ padding: "14px 15px" }}
                      >
                        {/* Product Info */}
                        <div className="row mb-10">
                          <div className="col-7">
                            <h6
                              className="product-title ms-20"
                              style={{
                                fontSize: "17px",
                                fontWeight: "400",
                                textTransform: "capitalize",
                              }}
                            >
                              Product Name : {order.itemname}
                            </h6>
                            <p
                              style={{
                                fontSize: "13px",
                                color: "grey",
                                fontWeight: "700",
                              }}
                            >
                              Seller : Shibani Fashion
                            </p>
                            <p
                              style={{
                                fontSize: "17px",
                                fontWeight: "600",
                                textTransform: "capitalize",
                              }}
                            >
                              ₹{order.totalprice} <br />
                              <Badge
                                bg={
                                  order.orderstatus === "completed"
                                    ? "success"
                                    : "danger"
                                }
                              >
                                {order.orderstatus}
                              </Badge>
                            </p>
                          </div>
                          <div className="col-5 d-flex justify-content-end">
                            <img
                              src={`${Api.CloudImageUrl}/${order.image}`}
                              style={{
                                height: "112px",
                                marginRight: "5px",
                                marginBottom: "5px",
                              }}
                              alt="product"
                            />
                          </div>
                        </div>

                        {/* Timeline */}
                        <hr />
                        <div className="timeline-wrapper my-4">
                          <div className="d-flex align-items-center">
                            <div
                              className={`timeline-circle me-3 ${
                                ["completed", "shipped", "delivered"].includes(
                                  order.orderstatus
                                )
                                  ? "bg-success"
                                  : order.orderstatus === "Payment pending"
                                  ? "bg-danger"
                                  : "bg-secondary"
                              }`}
                            >
                              <span className="text-white">
                                {["completed", "shipped", "delivered"].includes(
                                  order.orderstatus
                                )
                                  ? "✓"
                                  : "!"}
                              </span>
                            </div>
                            <div className="ms-10">
                              <div
                                className="fw-bold"
                                style={{ fontSize: "14px" }}
                              >
                                {["completed", "shipped", "delivered"].includes(
                                  order.orderstatus
                                )
                                  ? "Order Confirmed"
                                  : order.orderstatus === "Payment pending"
                                  ? "Payment Pending"
                                  : order.orderstatus}
                              </div>
                              <div
                                className="text-muted small"
                                style={{ fontSize: "12px" }}
                              >
                                {order.paymentdate} {order.paymenttime}
                              </div>
                            </div>
                          </div>

                          {order.orderstatus === "shipped" && (
                            <>
                              <div className="d-flex align-items-center">
                                <div className="timeline-circle me-3 bg-success">
                                  <span className="text-white">✓</span>
                                </div>
                                <div className="ms-10">
                                  <div
                                    className="fw-bold"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Product Shipped
                                  </div>

                                  <div
                                    className="text-muted small"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Your Product has been Shipped and it will
                                    Reach you within a week
                                  </div>
                                </div>
                              </div>

                              <div className="courier-details mt-3">
                                <div
                                  className="text-black"
                                  style={{ fontSize: "18px" }}
                                >
                                  Courier Details
                                </div>

                                <div className="row mt-3">
                                  <div className="col-6">
                                    <table className="table table-bordered courier-table">
                                      <tr>
                                        <td>Company Name</td>
                                        <td>{order.courier_name}</td>
                                      </tr>
                                      <tr>
                                        <td>Courier ID</td>
                                        <td>{order.courier_id}</td>
                                      </tr>
                                      <tr>
                                        <td>Contact Detail</td>
                                        <td>{order.courier_contact}</td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          {order.orderstatus === "delivered" && (
                            <div className="d-flex align-items-center">
                              <div className="timeline-circle me-3 bg-success">
                                <span className="text-white">✓</span>
                              </div>
                              <div className="ms-10">
                                <div
                                  className="fw-bold"
                                  style={{ fontSize: "14px" }}
                                >
                                  Product Delivered
                                </div>
                                <div
                                  className="text-muted small"
                                  style={{ fontSize: "12px" }}
                                >
                                  Thanks for ordering with us. Hope you like our
                                  service.
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                  <div
                    className="card w-100 h-100 text-center text-muted bb"
                    style={{ padding: "14px 15px" }}
                  >
                    <p
                      className="mb-10"
                      style={{ fontSize: "14px", fontWeight: "700" }}
                    >
                      Shipping Details
                    </p>
                    <hr />
                    <div>
                      <h6
                        className="text-start ms-10 mt-10"
                        style={{ fontSize: "17px", fontWeight: "600" }}
                      >
                        {context.state.userData.contactname || "N/A"}
                      </h6>
                      <p
                        className="text-start ms-10 text-muted"
                        style={{ fontSize: "14px" }}
                      >
                        {context.state.userData.shipping_address_1 || "N/A"}
                      </p>
                      <p
                        className="text-start ms-10 text-muted"
                        style={{ fontSize: "14px" }}
                      >
                        {context.state.userData.email || "N/A"}
                      </p>
                      <p
                        className="text-start ms-10 text-muted"
                        style={{ fontSize: "14px" }}
                      >
                        {context.state.userData.mobile || "N/A"}
                      </p>
                      <p
                        className="text-start ms-10 text-muted"
                        style={{ fontSize: "14px" }}
                      >
                        {context.state.userData.shipping_city || "N/A"}
                      </p>
                      <p
                        className="text-start ms-10 text-muted"
                        style={{ fontSize: "14px" }}
                      >
                        {context.state.userData.shipping_zip || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default withRouter(OrderDetails);
